import { apiRequest} from './index'

export const getClientsRequest = (filters) => {

  const {
    page=0,
    limit=0,
    search='',
    simplified='true',
    project='',
    status=''
  } = filters;

  return apiRequest(
    `/admin/clients?page=${page}&limit=${limit}&search=${search}&simplified=${simplified}&project=${project}&status=${status}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getClientRequest = (id) => {
  return apiRequest(
    `/admin/clients/${id}`,
    {
      method: 'GET'
    },
    true
  )
}
export const getClientInfoRequest = (id, info) => {
  return apiRequest(
    `/admin/clients/${id}/${info}`,
    {
      method: 'GET'
    },
    true
  )
}

export const updateClientRequest = (client) => {
  return apiRequest(
    `/admin/clients/${client._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(client)
    },
    true
  )
}

export const createClientRequest = (client) => {
  return apiRequest(
    `/admin/clients`,
    {
			method: 'POST',
			body: JSON.stringify(client)
    },
    true
  )
}

export const deleteClientRequest = (clientId) => {
  return apiRequest(
    `/admin/clients/${clientId}`,
    {
			method: 'DELETE'
    },
    true
  )
}

export const uploadClientDocument = async (clientId, file) => {
  const formData = new FormData();
	formData.append('file', file);

	const end_point = `${process.env.REACT_APP_API_ENDPOINT}/api/admin/clients/save-document-file/${clientId}`;

	const response = await fetch(end_point, {
		method: 'POST',
		body: formData
	})

	const data = await response.json()
	return data;
}

export const saveClientDocumentUrl = (id, data) => {
  return apiRequest(
    `/admin/clients/save-document-url/${id}`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    },
    true
  )
}